/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { isColliding } from '../utils/collider';
import { cssParser } from '../utils/parser';

const speedLevelMapping = {
    "speed-1": "2s",
    "speed-2": "1.5s",
    "speed-3": "1s",
    "speed-4": "0.5s",
}

const Fan = ({ css, onComplete }) => {
    const [speedLevel, setSpeedLevel] = useState("speed-1")

    const checkSpeedLevel = () => {
        if (isColliding(document.getElementById("speed-level-collider"), document.getElementById("speed-1"))) {
            setSpeedLevel("speed-1");
        }
        if (isColliding(document.getElementById("speed-level-collider"), document.getElementById("speed-2"))) {
            setSpeedLevel("speed-2");
        }
        if (isColliding(document.getElementById("speed-level-collider"), document.getElementById("speed-3"))) {
            setSpeedLevel("speed-3");
        }
        if (isColliding(document.getElementById("speed-level-collider"), document.getElementById("speed-4"))) {
            setSpeedLevel("speed-4");
            onComplete();
        }
    }

    useEffect(() => {
        checkSpeedLevel();
    }, [css])

    return (
        <div id="fan-level">
            <div id="fan-parent" className='absolute'>
                <img id="fan-body" className='absolute' height={300} src='/images/fan-body.png' alt="fan-body" />
                <img id="fan" style={{ 'animationDuration': speedLevelMapping[speedLevel] }} className='absolute' height={250} src='/images/fan.png' alt="fan" />
            </div>

            <div id="candle-parent" className='absolute'>
                <img id="candle" className='absolute' height={100} src='/images/candle.png' alt="candle" />
                {speedLevel !== "speed-4" &&
                    <img id="fire" style={{ 'animationDuration': speedLevelMapping[speedLevel] }} className='absolute' height={25} src='/images/fire.png' alt="fire" />}
            </div>
            <div id="speed-parent" className='absolute'>
                <img id="speed-level-base" className='absolute' height={200} src='/images/speed-level-base.png' alt="speed-level-base" />
                <div id="speed-1" className='absolute' style={{ "height": "20px", "width": "20px", "top": "90px", "left": "10px" }}></div>
                <div id="speed-2" className='absolute' style={{ "height": "20px", "width": "20px", "top": "30px", "left": "30px" }}></div>
                <div id="speed-3" className='absolute' style={{ "height": "20px", "width": "20px", "top": "10px", "left": "90px" }}></div>
                <div id="speed-4" className='absolute' style={{ "height": "20px", "width": "20px", "top": "30px", "left": "150px" }}></div>
                <div id="speed-level" className='absolute' style={cssParser(css)} >
                    <p style={{ "position": "absolute", "color": "black", "fontSize": "large" }}>#level-adjustor</p>
                    <div id="speed-level-collider" className='absolute' />
                    <img height={140} src='/images/speed-level.png' alt="speed-level" />
                </div>
            </div>
        </div>
    )
}

export default Fan;